/**
 * AppRouter - ルーティングロジック
 */

import { useCurrentMode } from '../store'
import { HomePage } from '../pages/HomePage'
import { CapturePage } from '../pages/CapturePage'
import { PlaybackPage } from '../pages/PlaybackPage'
import { GraphPage } from '../pages/GraphPage'
import { SettingsPage } from '../pages/SettingsPage'
import { DecksPage } from '../pages/DecksPage'
import { SimplifiedPlaybackPage } from '../pages/SimplifiedPlaybackPage'
import { logger } from '../lib/logger'

export function AppRouter() {
  const currentMode = useCurrentMode()
  
  logger.log('[AppRouter] Current mode:', currentMode)

  try {
    switch (currentMode) {
      case 'home':
        return <HomePage />
      case 'capture':
        return <CapturePage />
      case 'playback':
        return <PlaybackPage />
      case 'graph':
        return <GraphPage />
      case 'settings':
        return <SettingsPage />
      case 'decks':
        return <DecksPage />
      case 'simplified-playback':
        return <SimplifiedPlaybackPage />
      default:
        logger.log('[AppRouter] Unknown mode, defaulting to HomePage')
        return <HomePage />
    }
  } catch (error) {
    logger.error('[AppRouter] Error rendering component:', error)
    return <HomePage />
  }
}